import { sanitizeExcelValue } from "helpers";
import { ExcelCellProps, Point } from "types";

export type SchemaValidationResult = {
  isValid: boolean;
  errors: {
    message: string;
    coordinates: Point;
  }[];
};

const normalizeSchemaValue = (
  value: string | number | null | undefined,
  expectedType: ExcelCellProps["type"],
) => {
  let normalizedValue = sanitizeExcelValue(value);

  if (normalizedValue === "") {
    return null;
  }

  if (
    normalizedValue !== null &&
    normalizedValue !== undefined &&
    expectedType === "string" &&
    typeof normalizedValue !== "string"
  ) {
    return String(normalizedValue);
  }

  if (
    normalizedValue !== null &&
    normalizedValue !== undefined &&
    expectedType === "number" &&
    typeof normalizedValue === "string"
  ) {
    const parsedValue = Number(normalizedValue.replace(",", "."));

    if (!Number.isNaN(parsedValue)) {
      return parsedValue;
    }
  }

  return sanitizeExcelValue(normalizedValue);
};

export const validateSchema = <
  T extends Record<string, unknown>,
  S extends Record<string, ExcelCellProps>
>(
  values: T[],
  schema: S
): SchemaValidationResult => {
  const result: SchemaValidationResult = {
    isValid: true,
    errors: [],
  };

  values.forEach((value, index_Y) => {
    const clonedValue: Record<string, any> = { ...value };

    Object.keys(schema).forEach((key, index_X) => {
      const sanitizedValue = normalizeSchemaValue(
        clonedValue[key] as string | number | null | undefined,
        schema[key].type,
      );
      clonedValue[key] = sanitizedValue;

      if (schema[key].required && (sanitizedValue === null || sanitizedValue === undefined || sanitizedValue === "")) {
        result.isValid = false;
        result.errors.push({
          message: `El campo "${key}" es requerido, (Celda: ${index_X}, ${index_Y})`,
          coordinates: {
            x: index_X,
            y: index_Y,
          },
        });
      }

      if (
        sanitizedValue !== null &&
        sanitizedValue !== undefined &&
        typeof sanitizedValue !== schema[key].type
      ) {
        result.isValid = false;
        result.errors.push({
          message: `El campo "${key}" debe ser de tipo ${schema[key].type} y es de tipo ${typeof sanitizedValue}, (Celda: ${index_X}, ${index_Y})`,
          coordinates: {
            x: index_X,
            y: index_Y,
          },
        });
      }

      if (schema[key].associations && sanitizedValue !== null && sanitizedValue !== undefined) {
        const valueToCompare = sanitizedValue.toString().toLowerCase();

        const exists = schema[key].associations?.some(
          (assoc) => sanitizeExcelValue(assoc)?.toString().toLowerCase() === valueToCompare
        );

        if (!exists) {
          result.isValid = false;
          result.errors.push({
            message: `No existe "${sanitizedValue}", (Celda: ${index_X}, ${index_Y})`,
            coordinates: {
              x: index_X,
              y: index_Y,
            },
          });
        }
      }
    });
  });
  return result;
};
